import { render, staticRenderFns } from "./MiraStackedBar.vue?vue&type=template&id=0f154df6&scoped=true&"
import script from "./MiraStackedBar.vue?vue&type=script&lang=ts&"
export * from "./MiraStackedBar.vue?vue&type=script&lang=ts&"
import style0 from "./MiraStackedBar.vue?vue&type=style&index=0&id=0f154df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f154df6",
  null
  
)

export default component.exports